export default "__VITE_PUBLIC_ASSET__ce5d31b9__"